export const genetics = [
    {
      name: 'Sour Diesel',
      percentage: '21',
      terpenes: 'So sour your eyes water'
    },
    {
      name: 'Girl Scout Cookies Forum cut',
      percentage: '28',
      terpenes: 'Cookies and gas baby!'
    },
    {
      name: 'Gorilla Glue 4 Josey cut',
      percentage: '24',
      terpenes: 'Lime and pine'
    },
    {
      name: 'Obama Runtz',
      percentage: '20',
      terpenes: 'Presidential candy. U S A!'
    },
    {
      name: 'SFVOG',
      percentage: '19',
      terpenes: 'Earth and OG gas'
    },
    {
      name: 'Blue Andez',
      percentage: '25',
      terpenes: 'Blueberry and cookies'
    },
  ];